function eventListners() {
	const widgetTabs = document.querySelectorAll(".review-question-inner > span")
	const openReviewForm = document.querySelector(".add-review-inner")
	const openQuestionForm = document.querySelector(".ask-question-inner")
	const closeFormDrawer = document.querySelectorAll(".widget-drawer-close")
	const reviewForm = document.querySelector("#review_form")
	const questionForm = document.querySelector("#question_form")
	const reviewFormVisibility = document.querySelector("[review-form]")
	const questionFormVisibility = document.querySelector("[question-form]")
	const searchInput = document.querySelector("#review-search")
	const sortBy = document.querySelector(".selected-sortby")
	const sortByItem = document.querySelectorAll(".sortby-dropdown > span")
	const sortByDropdown = document.querySelector(".sortby-dropdown")
	const reviewImagesContainer = document.querySelector(
		".review-images-container"
	)
	const thumbsSelector = document.querySelectorAll(".thumbs-up-down")
	const reviewFileInput = document.querySelector(
		"[review-form] .wholescale-file-upload [name='images']"
	)
	const questionFileInput = document.querySelector(
		"[question-form] .wholescale-file-upload [name='images']"
	)
	const reviewImageListContainer = document.querySelector(
		"[review-form] .image-list"
	)
	const questionImageListContainer = document.querySelector(
		"[question-form] .image-list"
	)
	const reviewImagesArr = []
	const questionImagesArr = []
	const productId = document
		.querySelector("[data-product-id]")
		.getAttribute("data-product-id")
	// Review Submit Form
	reviewForm.addEventListener("submit", handleReviewSubmit)
	// Question Submit Form
	questionForm.addEventListener("submit", handleQuestionSubmit)

	function handleReviewSubmit(event) {
		event.preventDefault() // Prevent the default form submission
		document.querySelector("[review-form]").classList.add("loading")
		// update images array
		const filteredArray = reviewImagesArr.map(({ img_url, ...rest }) => rest)
		// Retrieve form data or perform other actions
		const formData = new FormData(event.target)
		const reviewData = {
			first_name: formData.get("first_name"),
			last_name: formData.get("last_name"),
			email: formData.get("email"),
			star: formData.get("rating"),
			title: formData.get("title"),
			description: formData.get("detail"),
			images: filteredArray,
			platform: "Shopify",
			product: productId,
			shop_url: Shopify.shop,
			blackBox: encodeURIComponent(window.blackBoxStr),
		}
		console.log(reviewData)
		submitReview(reviewData)
	}

	function submitReview(reviewData) {
		const url = "https://be.wholescale.net/shopifyWidget/reviewSubmission"
		const requestOptions = {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(reviewData),
		}
		fetch(url, requestOptions)
			.then((response) => console.log(response))
			.then((data) => {
				// Process the response data here
				document.querySelector(".wholescale-toast .toast-text").textContent =
					"Review Submitted Successfully"
				document.querySelector(".wholescale-toast").classList.add("active")
				reviewFormVisibility.classList.remove("active")
				document.querySelector("body").classList.remove("drawer-open")
				document.querySelector("[review-form]").classList.remove("loading")
				document.removeEventListener("click", updateReviewDrawer)
				setTimeout(function () {
					document.querySelector(".wholescale-toast").classList.remove("active")
				}, 4000)
			})
			.catch((error) => {
				console.error("Error:", error)
				document.querySelector("[review-form]").classList.remove("loading")
				// Handle any errors that occurred during the request
			})
	}

	function handleQuestionSubmit(event) {
		event.preventDefault() // Prevent the default form submission
		document.querySelector("[question-form]").classList.add("loading")
		// update images array
		const filteredArray = questionImagesArr.map(({ img_url, ...rest }) => rest)

		// Retrieve form data or perform other actions
		const formData = new FormData(event.target)
		const questionData = {
			first_name: formData.get("first_name"),
			last_name: formData.get("last_name"),
			email: formData.get("email"),
			question: formData.get("question"),
			images: filteredArray,
			platform: "Shopify",
			product: productId,
			shop_url: Shopify.shop,
			blackBox: encodeURIComponent(window.blackBoxStr),
		}
		console.log(questionData)
		submitQuestion(questionData)
	}
	function submitQuestion(reviewData) {
		const url = "https://be.wholescale.net/shopifyWidget/questionSubmission"
		const requestOptions = {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(reviewData),
		}
		fetch(url, requestOptions)
			.then((response) => console.log(response))
			.then((data) => {
				// Process the response data here
				document.querySelector(".wholescale-toast .toast-text").textContent =
					"Question Submitted Successfully"
				document.querySelector(".wholescale-toast").classList.add("active")
				questionFormVisibility.classList.remove("active")
				document.querySelector("body").classList.remove("drawer-open")
				document.querySelector("[question-form]").classList.remove("loading")
				document.removeEventListener("click", updateQuestionDrawer)
				setTimeout(function () {
					document.querySelector(".wholescale-toast").classList.remove("active")
				}, 4000)
			})
			.catch((error) => {
				console.error("Error:", error)
				document.querySelector("[question-form]").classList.remove("loading")
				// Handle any errors that occurred during the request
			})
	}
	widgetTabs?.forEach((item) => {
		item.addEventListener("click", (event) => {
			//handle click
			var selectedtab = event.target.getAttribute("data-tab-value")
			selectedtab === "questions"
				? (reviewImagesContainer.style.display = "none")
				: (reviewImagesContainer.style.display = "block")
			document
				.querySelector(".review-question-inner > span.active")
				.classList.remove("active")
			document
				.querySelector(".widget-container.active")
				.classList.remove("active")
			event.target.classList.add("active")
			document
				.querySelector("[" + selectedtab + "-container]")
				.classList.add("active")
		})
	})
	closeFormDrawer?.forEach((item) => {
		item.addEventListener("click", (event) => {
			//handle click
			event.target.closest(".active").classList.remove("active")
			document.querySelector("body").classList.remove("drawer-open")
			document.removeEventListener("click", updateQuestionDrawer)
			document.removeEventListener("click", updateReviewDrawer)
		})
	})

	openReviewForm?.addEventListener("click", (event) => {
		//handle click
		document.querySelector("[review-form]").classList.add("active")
		document.querySelector("body").classList.add("drawer-open")
		setTimeout(function () {
			document.addEventListener("click", updateReviewDrawer)
		}, 200)
	})
	openQuestionForm?.addEventListener("click", (event) => {
		//handle click
		document.querySelector("[question-form]").classList.add("active")
		document.querySelector("body").classList.add("drawer-open")
		setTimeout(function () {
			document.addEventListener("click", updateQuestionDrawer)
		}, 200)
	})

	// Close drawer when click outside of review drawer
	function updateReviewDrawer(event) {
		// Check if the clicked element is the element you want to keep visible
		if (
			event.target !== reviewFormVisibility &&
			!reviewFormVisibility.contains(event.target)
		) {
			// Hide the element if it is not the element you want to keep visible
			reviewFormVisibility.classList.remove("active")
			document.querySelector("body").classList.remove("drawer-open")
			document.removeEventListener("click", updateReviewDrawer)
		}
	}
	// Close drawer when click outside of question drawer
	function updateQuestionDrawer(event) {
		// Check if the clicked element is the element you want to keep visible
		if (
			event.target !== questionFormVisibility &&
			!questionFormVisibility.contains(event.target)
		) {
			// Hide the element if it is not the element you want to keep visible
			questionFormVisibility.classList.remove("active")
			document.querySelector("body").classList.remove("drawer-open")
			document.removeEventListener("click", updateQuestionDrawer)
		}
	}
	// Close dropdown when click outside of sortBy Dropdown
	function updateSortByDropdown(event) {
		// Check if the clicked element is the element you want to keep visible
		if (
			event.target !== sortByDropdown &&
			!sortByDropdown.contains(event.target)
		) {
			// Hide the element if it is not the element you want to keep visible
			sortByDropdown.classList.remove("active")
			document.removeEventListener("click", updateSortByDropdown)
		}
	}
	// open sort by
	sortBy?.addEventListener("click", (event) => {
		//handle click
		sortByDropdown.classList.toggle("active")
		if (sortByDropdown.classList.value.includes("active")) {
			setTimeout(function () {
				document.addEventListener("click", updateSortByDropdown)
			}, 200)
		}
	})

	sortByItem?.forEach((item) => {
		item.addEventListener("click", (event) => {
			//handle click
			var selectedValue = event.target.getAttribute("data-value")
			document.querySelector("[sortby-value]").textContent = selectedValue
			document
				.querySelector(".sortby-dropdown  > span.active")
				.classList.remove("active")
			event.target.classList.add("active")
			sortByDropdown.classList.remove("active")
			document.removeEventListener("click", updateSortByDropdown)
			defaultSortBy = selectedValue
			window.fetchReviewsList()
			window.fetchReviewImages()
		})
	})

	// Thumbs Up down api

	window.submitReviewThumbs = function (data, event) {
		const url = "https://be.wholescale.net/shopifyWidget/reviewFeedBack"
		const requestOptions = {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(data),
		}
		fetch(url, requestOptions)
			.then((response) => console.log(response))
			.then((data) => {
				// Process the response data here
			})
			.catch((error) => {
				console.error("Error:", error)
				// Handle any errors that occurred during the request
			})
	}

	// Thumb up down click event

	document
		.querySelector(".reviews-list-inner")
		.addEventListener("click", function (event) {
			// Check if the clicked element has the class thumbs-up-down
			console.log(
				"event.target.classList",
				event.target.closest(".reviews-list-item")
			)
			let reviewId = event.target
				.closest(".reviews-list-item")
				.getAttribute("data-review-id")
			if (event.target.closest(".block-click")) {
				return
			}
			if (
				(event.target.classList.contains("thumbs-up-down") ||
					event.target.closest(".thumbs-up-down")) &&
				!event.target.closest(".block-click")
			) {
				// Handle the click event here
				console.log("Thumbs up or down clicked!")
				console.log(event.target)
				event.target.closest(".thumbs-up-down").classList.add("block-click")
				if (event.target.closest(".thumbs-down")) {
					const thumbsDownBody = {
						id: reviewId,
						is_liked: false,
					}
					const thumbsDownCounter = event.target
						.closest(".thumbs-down")
						.querySelector("span").textContent
					event.target
						.closest(".thumbs-down")
						.querySelector("span").textContent = Number(thumbsDownCounter) + 1
					window.submitReviewThumbs(thumbsDownBody, event)
				} else {
					const thumbsUpBody = {
						id: reviewId,
						is_liked: true,
					}
					const thumbsUpCounter = event.target
						.closest(".thumbs-up")
						.querySelector("span").textContent
					event.target.closest(".thumbs-up").querySelector("span").textContent =
						Number(thumbsUpCounter) + 1
					window.submitReviewThumbs(thumbsUpBody, event)
				}
			}
		})

	// Render Review Media Images
	function renderReviewImages() {
		document.querySelector("[review-form] .uploaded-images").innerHTML = ""
		reviewImagesArr.forEach(function (item, index) {
			console.log(item, index)
			let image = `
          <div class="image-item" data-index=${index}>
            <img src="${item.img_url}">
            <svg class="remove-image" data-index=${index} focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="CloseIcon" index="0"><path data-index=${index} class="remove-image" d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path></svg>
          </div>`
			document.querySelector("[review-form] .uploaded-images").innerHTML +=
				image
		})
		document.querySelector("[review-form] .images-limit-text").style.display =
			"none"
		reviewFileInput.removeAttribute("disabled", true)
	}
	// Review Upload Image func
	reviewFileInput.addEventListener("change", (event) => {
		console.log(reviewFileInput.files)
		var files = reviewFileInput.files
		console.log(reviewImagesArr.length)
		if (files.length && reviewImagesArr.length <= 3) {
			document.querySelector("[review-form] .images-limit-text").style.display =
				"none"
			reviewFileInput.removeAttribute("disabled", true)
			const reader = new FileReader()
			reader.onloadend = function () {
				const base64String = reader.result
				// Perform actions with the Base64 encoded string here
				reviewImagesArr.push({
					image: base64String,
					img_url: window.URL.createObjectURL(files[0]),
				})
				renderReviewImages()
			}
			reader.readAsDataURL(files[0])
		} else if (reviewImagesArr.length > 3) {
			document.querySelector("[review-form] .images-limit-text").style.display =
				"block"
			reviewFileInput.setAttribute("disabled", true)
			reviewFileInput.value = ""
		}
	})

	// Update Images grid
	reviewImageListContainer.addEventListener("click", (event) => {
		//handle click
		event.stopPropagation()
		console.log(event.target)
		if (event.target.classList.contains("remove-image")) {
			let currIndex = event.target.getAttribute("data-index")
			reviewImagesArr.splice(currIndex, 1)
			renderReviewImages()
			reviewFileInput.value = ""
		}
	})

	// Render Review Media Images
	function renderQuestionImages() {
		document.querySelector("[question-form] .uploaded-images").innerHTML = ""
		questionImagesArr.forEach(function (item, index) {
			console.log(item, index)
			let image = `
            <div class="image-item" data-index=${index}>
              <img src="${item.img_url}">
              <svg class="remove-image" data-index=${index} focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="CloseIcon" index="0"><path data-index=${index} class="remove-image" d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path></svg>
            </div>`
			document.querySelector("[question-form] .uploaded-images").innerHTML +=
				image
		})
		document.querySelector("[question-form] .images-limit-text").style.display =
			"none"
		questionFileInput.removeAttribute("disabled", true)
	}
	// Review Upload Image func
	questionFileInput.addEventListener("change", (event) => {
		console.log(reviewFileInput.files)
		var questionFiles = questionFileInput.files
		console.log(questionImagesArr.length)
		if (questionFiles.length && questionImagesArr.length <= 3) {
			document.querySelector(
				"[question-form] .images-limit-text"
			).style.display = "none"
			questionFileInput.removeAttribute("disabled", true)
			const reader = new FileReader()
			reader.onloadend = function () {
				const base64String = reader.result
				// Perform actions with the Base64 encoded string here
				questionImagesArr.push({
					image: base64String,
					img_url: window.URL.createObjectURL(questionFiles[0]),
				})
				renderQuestionImages()
			}
			reader.readAsDataURL(questionFiles[0])
		} else if (questionImagesArr.length > 3) {
			document.querySelector(
				"[question-form] .images-limit-text"
			).style.display = "block"
			questionFileInput.setAttribute("disabled", true)
			questionFileInput.value = ""
		}
	})

	// Update Images grid
	questionImageListContainer.addEventListener("click", (event) => {
		//handle click
		event.stopPropagation()
		console.log(event.target)
		if (event.target.classList.contains("remove-image")) {
			let currIndex = event.target.getAttribute("data-index")
			questionImagesArr.splice(currIndex, 1)
			renderQuestionImages()
			questionFileInput.value = ""
		}
	})

	// search event listener
	// Add the debounced change event listener
	// Debounce function
	function debounce(func, delay) {
		let timeoutId

		return function (...args) {
			clearTimeout(timeoutId)
			timeoutId = setTimeout(() => {
				func.apply(this, args)
			}, delay)
		}
	}
	// Event handler function
	function handleChange(event) {
		// Handle input change here
		searchTerm = event.target.value
		window.fetchReviewsList()
	}
	const debouncedHandleChange = debounce(handleChange, 300)
	searchInput.addEventListener("keyup", debouncedHandleChange)
}

document.addEventListener("DOMContentLoaded", function () {
	// do something here ...
	let defaultSortBy = ""
	let searchTerm = ""
	fetchWholescaleWidgetInfo()
	eventListners()
})
function renderReviews(data) {
	const reviewList = document.querySelector(".reviews-list-inner")
	reviewList.innerHTML = ""
	data.results.forEach(function (item, index) {
		console.log(item)
		let reviewItem = `
      <div class="reviews-list-item" data-index="${index}" data-review-id="${
			item?.id
		}">
      <div class="review-alphabet-title">
        <span class="first-alphabet" style="background-color: ${localStorage.getItem(
					"star_color"
				)}"> ${item?.customer?.first_name?.charAt(0).toUpperCase()} </span>
      </div>
      <div class="review-content">
        <div class="review-content-top">
          <div class="name-rating">
          ${
						item?.liked_count > item?.disliked_count && item?.liked_count > 5
							? `<div class="would-recommend">
            <svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiSvgIcon-root MuiSvgIcon-fontSizeLarge css-p79yt4" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="ThumbUpIcon" tabindex="-1" title="ThumbUp"><path d="M1 21h4V9H1zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73z"></path></svg>
            <p> Would Recommend  </p>
          </div>`
							: ""
					}
            <span class="name"> ${
							item?.customer?.first_name
						} ${item?.customer?.last_name?.charAt(0).toUpperCase()} </span>
            <span class="rating rating-${item.stars}">
              <svg width="13" height="12" viewBox="0 0 28 26" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M2.32346 10.9272C2.40971 10.9272 2.4744 10.9272 2.56066 10.9272C5.36389 10.9272 8.16713 10.9272 10.9704 10.9272C11.0997 10.9272 11.1429 10.8841 11.1644 10.7763C12.0701 8.01619 12.9758 5.25608 13.8814 2.49597C13.903 2.43128 13.9245 2.38815 13.9677 2.28033C14.1833 2.92723 14.3774 3.55257 14.5714 4.17791C15.2615 6.35581 15.9299 8.51214 16.62 10.69C16.6846 10.8625 16.7493 10.9272 16.9434 10.9272C19.7466 10.9272 22.5714 10.9272 25.3747 10.9272C25.4609 10.9272 25.5472 10.9272 25.6766 10.9272C25.5903 10.9919 25.5472 11.0351 25.5041 11.0782C23.2183 12.7386 20.9542 14.3774 18.6685 16.0378C18.6469 16.0593 18.6038 16.0809 18.5822 16.1024C18.4097 16.1887 18.3666 16.2965 18.4313 16.4906C19.2938 19.1213 20.1348 21.752 20.9973 24.3828C21.0189 24.4475 21.0404 24.5337 21.0836 24.6631C20.9758 24.5984 20.9111 24.5553 20.8464 24.5121C18.6038 22.8733 16.3828 21.2345 14.1617 19.5957C14.0108 19.4879 13.903 19.4663 13.752 19.5957C11.4448 21.2345 9.15904 22.8733 6.85176 24.4906C6.78707 24.5337 6.72238 24.5768 6.63613 24.6415C6.65769 24.5337 6.67926 24.469 6.70082 24.4043C7.56335 21.7089 8.40432 19.0351 9.26686 16.3396C9.33155 16.1671 9.28842 16.0809 9.13748 15.9731C6.93802 14.3558 4.71699 12.7386 2.51753 11.1213C2.43128 11.0566 2.36659 11.0135 2.28033 10.9488C2.32346 10.9488 2.32346 10.9488 2.32346 10.9272Z" stroke="black" stroke-miterlimit="10"/>
							</svg>
							<svg width="13" height="12" viewBox="0 0 28 26" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M2.32346 10.9272C2.40971 10.9272 2.4744 10.9272 2.56066 10.9272C5.36389 10.9272 8.16713 10.9272 10.9704 10.9272C11.0997 10.9272 11.1429 10.8841 11.1644 10.7763C12.0701 8.01619 12.9758 5.25608 13.8814 2.49597C13.903 2.43128 13.9245 2.38815 13.9677 2.28033C14.1833 2.92723 14.3774 3.55257 14.5714 4.17791C15.2615 6.35581 15.9299 8.51214 16.62 10.69C16.6846 10.8625 16.7493 10.9272 16.9434 10.9272C19.7466 10.9272 22.5714 10.9272 25.3747 10.9272C25.4609 10.9272 25.5472 10.9272 25.6766 10.9272C25.5903 10.9919 25.5472 11.0351 25.5041 11.0782C23.2183 12.7386 20.9542 14.3774 18.6685 16.0378C18.6469 16.0593 18.6038 16.0809 18.5822 16.1024C18.4097 16.1887 18.3666 16.2965 18.4313 16.4906C19.2938 19.1213 20.1348 21.752 20.9973 24.3828C21.0189 24.4475 21.0404 24.5337 21.0836 24.6631C20.9758 24.5984 20.9111 24.5553 20.8464 24.5121C18.6038 22.8733 16.3828 21.2345 14.1617 19.5957C14.0108 19.4879 13.903 19.4663 13.752 19.5957C11.4448 21.2345 9.15904 22.8733 6.85176 24.4906C6.78707 24.5337 6.72238 24.5768 6.63613 24.6415C6.65769 24.5337 6.67926 24.469 6.70082 24.4043C7.56335 21.7089 8.40432 19.0351 9.26686 16.3396C9.33155 16.1671 9.28842 16.0809 9.13748 15.9731C6.93802 14.3558 4.71699 12.7386 2.51753 11.1213C2.43128 11.0566 2.36659 11.0135 2.28033 10.9488C2.32346 10.9488 2.32346 10.9488 2.32346 10.9272Z" stroke="black" stroke-miterlimit="10"/>
							</svg>
							<svg width="13" height="12" viewBox="0 0 28 26" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M2.32346 10.9272C2.40971 10.9272 2.4744 10.9272 2.56066 10.9272C5.36389 10.9272 8.16713 10.9272 10.9704 10.9272C11.0997 10.9272 11.1429 10.8841 11.1644 10.7763C12.0701 8.01619 12.9758 5.25608 13.8814 2.49597C13.903 2.43128 13.9245 2.38815 13.9677 2.28033C14.1833 2.92723 14.3774 3.55257 14.5714 4.17791C15.2615 6.35581 15.9299 8.51214 16.62 10.69C16.6846 10.8625 16.7493 10.9272 16.9434 10.9272C19.7466 10.9272 22.5714 10.9272 25.3747 10.9272C25.4609 10.9272 25.5472 10.9272 25.6766 10.9272C25.5903 10.9919 25.5472 11.0351 25.5041 11.0782C23.2183 12.7386 20.9542 14.3774 18.6685 16.0378C18.6469 16.0593 18.6038 16.0809 18.5822 16.1024C18.4097 16.1887 18.3666 16.2965 18.4313 16.4906C19.2938 19.1213 20.1348 21.752 20.9973 24.3828C21.0189 24.4475 21.0404 24.5337 21.0836 24.6631C20.9758 24.5984 20.9111 24.5553 20.8464 24.5121C18.6038 22.8733 16.3828 21.2345 14.1617 19.5957C14.0108 19.4879 13.903 19.4663 13.752 19.5957C11.4448 21.2345 9.15904 22.8733 6.85176 24.4906C6.78707 24.5337 6.72238 24.5768 6.63613 24.6415C6.65769 24.5337 6.67926 24.469 6.70082 24.4043C7.56335 21.7089 8.40432 19.0351 9.26686 16.3396C9.33155 16.1671 9.28842 16.0809 9.13748 15.9731C6.93802 14.3558 4.71699 12.7386 2.51753 11.1213C2.43128 11.0566 2.36659 11.0135 2.28033 10.9488C2.32346 10.9488 2.32346 10.9488 2.32346 10.9272Z" stroke="black" stroke-miterlimit="10"/>
							</svg>
							<svg width="13" height="12" viewBox="0 0 28 26" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M2.32346 10.9272C2.40971 10.9272 2.4744 10.9272 2.56066 10.9272C5.36389 10.9272 8.16713 10.9272 10.9704 10.9272C11.0997 10.9272 11.1429 10.8841 11.1644 10.7763C12.0701 8.01619 12.9758 5.25608 13.8814 2.49597C13.903 2.43128 13.9245 2.38815 13.9677 2.28033C14.1833 2.92723 14.3774 3.55257 14.5714 4.17791C15.2615 6.35581 15.9299 8.51214 16.62 10.69C16.6846 10.8625 16.7493 10.9272 16.9434 10.9272C19.7466 10.9272 22.5714 10.9272 25.3747 10.9272C25.4609 10.9272 25.5472 10.9272 25.6766 10.9272C25.5903 10.9919 25.5472 11.0351 25.5041 11.0782C23.2183 12.7386 20.9542 14.3774 18.6685 16.0378C18.6469 16.0593 18.6038 16.0809 18.5822 16.1024C18.4097 16.1887 18.3666 16.2965 18.4313 16.4906C19.2938 19.1213 20.1348 21.752 20.9973 24.3828C21.0189 24.4475 21.0404 24.5337 21.0836 24.6631C20.9758 24.5984 20.9111 24.5553 20.8464 24.5121C18.6038 22.8733 16.3828 21.2345 14.1617 19.5957C14.0108 19.4879 13.903 19.4663 13.752 19.5957C11.4448 21.2345 9.15904 22.8733 6.85176 24.4906C6.78707 24.5337 6.72238 24.5768 6.63613 24.6415C6.65769 24.5337 6.67926 24.469 6.70082 24.4043C7.56335 21.7089 8.40432 19.0351 9.26686 16.3396C9.33155 16.1671 9.28842 16.0809 9.13748 15.9731C6.93802 14.3558 4.71699 12.7386 2.51753 11.1213C2.43128 11.0566 2.36659 11.0135 2.28033 10.9488C2.32346 10.9488 2.32346 10.9488 2.32346 10.9272Z" stroke="black" stroke-miterlimit="10"/>
							</svg>
							<svg width="13" height="12" viewBox="0 0 28 26" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M2.32346 10.9272C2.40971 10.9272 2.4744 10.9272 2.56066 10.9272C5.36389 10.9272 8.16713 10.9272 10.9704 10.9272C11.0997 10.9272 11.1429 10.8841 11.1644 10.7763C12.0701 8.01619 12.9758 5.25608 13.8814 2.49597C13.903 2.43128 13.9245 2.38815 13.9677 2.28033C14.1833 2.92723 14.3774 3.55257 14.5714 4.17791C15.2615 6.35581 15.9299 8.51214 16.62 10.69C16.6846 10.8625 16.7493 10.9272 16.9434 10.9272C19.7466 10.9272 22.5714 10.9272 25.3747 10.9272C25.4609 10.9272 25.5472 10.9272 25.6766 10.9272C25.5903 10.9919 25.5472 11.0351 25.5041 11.0782C23.2183 12.7386 20.9542 14.3774 18.6685 16.0378C18.6469 16.0593 18.6038 16.0809 18.5822 16.1024C18.4097 16.1887 18.3666 16.2965 18.4313 16.4906C19.2938 19.1213 20.1348 21.752 20.9973 24.3828C21.0189 24.4475 21.0404 24.5337 21.0836 24.6631C20.9758 24.5984 20.9111 24.5553 20.8464 24.5121C18.6038 22.8733 16.3828 21.2345 14.1617 19.5957C14.0108 19.4879 13.903 19.4663 13.752 19.5957C11.4448 21.2345 9.15904 22.8733 6.85176 24.4906C6.78707 24.5337 6.72238 24.5768 6.63613 24.6415C6.65769 24.5337 6.67926 24.469 6.70082 24.4043C7.56335 21.7089 8.40432 19.0351 9.26686 16.3396C9.33155 16.1671 9.28842 16.0809 9.13748 15.9731C6.93802 14.3558 4.71699 12.7386 2.51753 11.1213C2.43128 11.0566 2.36659 11.0135 2.28033 10.9488C2.32346 10.9488 2.32346 10.9488 2.32346 10.9272Z" stroke="black" stroke-miterlimit="10"/>
							</svg>
            </span>
          </div>
          <div class="review-date">
            <span class="date"> ${item?.created_at} </span>
          </div>
        </div>
        <div class="review-content-bottom">
        ${item?.title ? `<p class="review-title">${item?.title}</p>` : ""}
        ${
					item.description
						? `<p class="review-description">${item?.description}</p>`
						: ""
				}
        ${
					item.answer
						? `<p class="review-answer"> <label> Reply: </label> ${item?.answer}</p>`
						: ""
				}
        </div>
        ${
					item?.submission_images.length > 0
						? `<div class="media-images">
          <div class="images-list">
          ${item?.submission_images?.map(
						(obj, index) =>
							`<div class="images-item" data-index="${index}"> <img src="${obj.image}"/> </div>`
					)}
          </div>
        </div>`
						: ""
				}
      </div>
      <div class="share-container">
      <div class="share-inner">
          <div class="share-left">
            <div class="share-action-button">
              <span class="share-icon">
              <svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiSvgIcon-root MuiSvgIcon-fontSizeLarge css-p79yt4" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="IosShareIcon" tabindex="-1" title="IosShare"><path d="m16 5-1.42 1.42-1.59-1.59V16h-1.98V4.83L9.42 6.42 8 5l4-4zm4 5v11c0 1.1-.9 2-2 2H6c-1.11 0-2-.9-2-2V10c0-1.11.89-2 2-2h3v2H6v11h12V10h-3V8h3c1.1 0 2 .89 2 2"></path></svg>
              <p> Share </p>
              </span>
              <div class="share-list">
                  <span class="line-seperator"> | </span>
                  <a href="https://www.facebook.com/sharer/sharer.php?u=${
										window.location.href
									}&quote=Wholescale reviews widget" target="_blank"> Facebook </a>
                  <span> - </span>
                  <a href="https://twitter.com/intent/tweet?url=${
										window.location.href
									}&text=Wholescale reviews widget" target="_blank" > Twitter </a>
                  <span> - </span>
                  <a href="https://www.linkedin.com/sharing/share-offsite/?url=${
										window.location.href
									}&summary=Wholescale reviews widget" target="_blank"> Linkedin </a>
              </div>
            </div>
          </div>
          <div class="share-right">
            <p> Was this review helpful?</p>
            <div class="thumbs-up-down" >
              <p class="thumbs-up">
                <svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiSvgIcon-root MuiSvgIcon-fontSizeLarge css-p79yt4" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="ThumbUpIcon" tabindex="-1" title="ThumbUp"><path d="M1 21h4V9H1zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73z"></path></svg>
              <span> ${item?.liked_count} </span>
              </p>
              <p class="thumbs-down">
                <svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiSvgIcon-root MuiSvgIcon-fontSizeLarge css-p79yt4" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="ThumbDownIcon" tabindex="-1" title="ThumbDown"><path d="M15 3H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v2c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 23l6.59-6.59c.36-.36.58-.86.58-1.41V5c0-1.1-.9-2-2-2m4 0v12h4V3z"></path></svg>
              <span> ${item?.disliked_count} </span>
              </p>
            </div>
          </div>
      </div>
      </div>
    </div>
      `
		reviewList.innerHTML += reviewItem
		document.querySelector(".reviews-list-inner").style.fill =
			localStorage.getItem("star_color")
		document.querySelector(".reviews-list-inner").style.stroke =
			localStorage.getItem("star_color")
	})

	renderSurfaceKeyReviews(data.results[0])
}
function renderQuestions(data) {
	const questionList = document.querySelector(".question-list-inner")
	questionList.innerHTML = ""
	data.results.forEach(function (item, index) {
		console.log(item)
		let questionItem = `
      <div class="question-list-item" data-index="${index}">
      <div class="question-title">
      <span class="first-alphabet" style="background-color: ${localStorage.getItem(
				"star_color"
			)}"> ${item?.customer?.first_name?.charAt(0).toUpperCase()} </span>
      </div>
      <div class="question-content">
        <div class="question-content-top">
          <div class="name-rating">
          <span class="name"> ${
						item?.customer?.first_name
					} ${item?.customer?.last_name?.charAt(0).toUpperCase()} </span>
          </div>
          <div class="question-date">
            <span class="date"> ${item?.created_at} </span>
          </div>
        </div>
        <div class="question-content-bottom">
          <div class="question-content">
            <p><label> Question: </label> ${item?.question}</p>
          </div>
          ${
						item?.answer
							? `
          <p class="answer">
            <label> Answer: </label>
            ${item?.answer}
          </p>
          `
							: ""
					}
          ${
						item?.question_images.length > 0
							? `<div class="media-images">
            <div class="images-list">
            ${item?.question_images?.map(
							(obj, index) =>
								`<div class="images-item" data-index="${index}"> <img src="${obj.image}"/> </div>`
						)}
            </div>
          </div>`
							: ""
					}
        </div>
      </div>
    </div>
      `
		questionList.innerHTML += questionItem
	})
	document.querySelector(".question-list-inner").style.fill =
		localStorage.getItem("star_color")
	document.querySelector(".question-list-inner").style.stroke =
		localStorage.getItem("star_color")
}

function renderSurfaceKeyReviews(data) {
	const surfaceKeyReviews = document.querySelector("#surface-key-reviews")
	if (surfaceKeyReviews) {
		surfaceKeyReviews.innerHTML = `
			<div class="surface-key-reviews">
				<div class="surface-key-reviews-header">
					<div class="surface-key-reviews-header-left">
						<div class="surface-key-reviews__author">${data?.customer?.first_name} ${data?.customer?.last_name}</div>
						<span class="rating rating-${data?.stars}">
              <svg width="13" height="12" viewBox="0 0 28 26" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M2.32346 10.9272C2.40971 10.9272 2.4744 10.9272 2.56066 10.9272C5.36389 10.9272 8.16713 10.9272 10.9704 10.9272C11.0997 10.9272 11.1429 10.8841 11.1644 10.7763C12.0701 8.01619 12.9758 5.25608 13.8814 2.49597C13.903 2.43128 13.9245 2.38815 13.9677 2.28033C14.1833 2.92723 14.3774 3.55257 14.5714 4.17791C15.2615 6.35581 15.9299 8.51214 16.62 10.69C16.6846 10.8625 16.7493 10.9272 16.9434 10.9272C19.7466 10.9272 22.5714 10.9272 25.3747 10.9272C25.4609 10.9272 25.5472 10.9272 25.6766 10.9272C25.5903 10.9919 25.5472 11.0351 25.5041 11.0782C23.2183 12.7386 20.9542 14.3774 18.6685 16.0378C18.6469 16.0593 18.6038 16.0809 18.5822 16.1024C18.4097 16.1887 18.3666 16.2965 18.4313 16.4906C19.2938 19.1213 20.1348 21.752 20.9973 24.3828C21.0189 24.4475 21.0404 24.5337 21.0836 24.6631C20.9758 24.5984 20.9111 24.5553 20.8464 24.5121C18.6038 22.8733 16.3828 21.2345 14.1617 19.5957C14.0108 19.4879 13.903 19.4663 13.752 19.5957C11.4448 21.2345 9.15904 22.8733 6.85176 24.4906C6.78707 24.5337 6.72238 24.5768 6.63613 24.6415C6.65769 24.5337 6.67926 24.469 6.70082 24.4043C7.56335 21.7089 8.40432 19.0351 9.26686 16.3396C9.33155 16.1671 9.28842 16.0809 9.13748 15.9731C6.93802 14.3558 4.71699 12.7386 2.51753 11.1213C2.43128 11.0566 2.36659 11.0135 2.28033 10.9488C2.32346 10.9488 2.32346 10.9488 2.32346 10.9272Z" stroke="black" stroke-miterlimit="10"/>
							</svg>
							<svg width="13" height="12" viewBox="0 0 28 26" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M2.32346 10.9272C2.40971 10.9272 2.4744 10.9272 2.56066 10.9272C5.36389 10.9272 8.16713 10.9272 10.9704 10.9272C11.0997 10.9272 11.1429 10.8841 11.1644 10.7763C12.0701 8.01619 12.9758 5.25608 13.8814 2.49597C13.903 2.43128 13.9245 2.38815 13.9677 2.28033C14.1833 2.92723 14.3774 3.55257 14.5714 4.17791C15.2615 6.35581 15.9299 8.51214 16.62 10.69C16.6846 10.8625 16.7493 10.9272 16.9434 10.9272C19.7466 10.9272 22.5714 10.9272 25.3747 10.9272C25.4609 10.9272 25.5472 10.9272 25.6766 10.9272C25.5903 10.9919 25.5472 11.0351 25.5041 11.0782C23.2183 12.7386 20.9542 14.3774 18.6685 16.0378C18.6469 16.0593 18.6038 16.0809 18.5822 16.1024C18.4097 16.1887 18.3666 16.2965 18.4313 16.4906C19.2938 19.1213 20.1348 21.752 20.9973 24.3828C21.0189 24.4475 21.0404 24.5337 21.0836 24.6631C20.9758 24.5984 20.9111 24.5553 20.8464 24.5121C18.6038 22.8733 16.3828 21.2345 14.1617 19.5957C14.0108 19.4879 13.903 19.4663 13.752 19.5957C11.4448 21.2345 9.15904 22.8733 6.85176 24.4906C6.78707 24.5337 6.72238 24.5768 6.63613 24.6415C6.65769 24.5337 6.67926 24.469 6.70082 24.4043C7.56335 21.7089 8.40432 19.0351 9.26686 16.3396C9.33155 16.1671 9.28842 16.0809 9.13748 15.9731C6.93802 14.3558 4.71699 12.7386 2.51753 11.1213C2.43128 11.0566 2.36659 11.0135 2.28033 10.9488C2.32346 10.9488 2.32346 10.9488 2.32346 10.9272Z" stroke="black" stroke-miterlimit="10"/>
							</svg>
							<svg width="13" height="12" viewBox="0 0 28 26" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M2.32346 10.9272C2.40971 10.9272 2.4744 10.9272 2.56066 10.9272C5.36389 10.9272 8.16713 10.9272 10.9704 10.9272C11.0997 10.9272 11.1429 10.8841 11.1644 10.7763C12.0701 8.01619 12.9758 5.25608 13.8814 2.49597C13.903 2.43128 13.9245 2.38815 13.9677 2.28033C14.1833 2.92723 14.3774 3.55257 14.5714 4.17791C15.2615 6.35581 15.9299 8.51214 16.62 10.69C16.6846 10.8625 16.7493 10.9272 16.9434 10.9272C19.7466 10.9272 22.5714 10.9272 25.3747 10.9272C25.4609 10.9272 25.5472 10.9272 25.6766 10.9272C25.5903 10.9919 25.5472 11.0351 25.5041 11.0782C23.2183 12.7386 20.9542 14.3774 18.6685 16.0378C18.6469 16.0593 18.6038 16.0809 18.5822 16.1024C18.4097 16.1887 18.3666 16.2965 18.4313 16.4906C19.2938 19.1213 20.1348 21.752 20.9973 24.3828C21.0189 24.4475 21.0404 24.5337 21.0836 24.6631C20.9758 24.5984 20.9111 24.5553 20.8464 24.5121C18.6038 22.8733 16.3828 21.2345 14.1617 19.5957C14.0108 19.4879 13.903 19.4663 13.752 19.5957C11.4448 21.2345 9.15904 22.8733 6.85176 24.4906C6.78707 24.5337 6.72238 24.5768 6.63613 24.6415C6.65769 24.5337 6.67926 24.469 6.70082 24.4043C7.56335 21.7089 8.40432 19.0351 9.26686 16.3396C9.33155 16.1671 9.28842 16.0809 9.13748 15.9731C6.93802 14.3558 4.71699 12.7386 2.51753 11.1213C2.43128 11.0566 2.36659 11.0135 2.28033 10.9488C2.32346 10.9488 2.32346 10.9488 2.32346 10.9272Z" stroke="black" stroke-miterlimit="10"/>
							</svg>
							<svg width="13" height="12" viewBox="0 0 28 26" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M2.32346 10.9272C2.40971 10.9272 2.4744 10.9272 2.56066 10.9272C5.36389 10.9272 8.16713 10.9272 10.9704 10.9272C11.0997 10.9272 11.1429 10.8841 11.1644 10.7763C12.0701 8.01619 12.9758 5.25608 13.8814 2.49597C13.903 2.43128 13.9245 2.38815 13.9677 2.28033C14.1833 2.92723 14.3774 3.55257 14.5714 4.17791C15.2615 6.35581 15.9299 8.51214 16.62 10.69C16.6846 10.8625 16.7493 10.9272 16.9434 10.9272C19.7466 10.9272 22.5714 10.9272 25.3747 10.9272C25.4609 10.9272 25.5472 10.9272 25.6766 10.9272C25.5903 10.9919 25.5472 11.0351 25.5041 11.0782C23.2183 12.7386 20.9542 14.3774 18.6685 16.0378C18.6469 16.0593 18.6038 16.0809 18.5822 16.1024C18.4097 16.1887 18.3666 16.2965 18.4313 16.4906C19.2938 19.1213 20.1348 21.752 20.9973 24.3828C21.0189 24.4475 21.0404 24.5337 21.0836 24.6631C20.9758 24.5984 20.9111 24.5553 20.8464 24.5121C18.6038 22.8733 16.3828 21.2345 14.1617 19.5957C14.0108 19.4879 13.903 19.4663 13.752 19.5957C11.4448 21.2345 9.15904 22.8733 6.85176 24.4906C6.78707 24.5337 6.72238 24.5768 6.63613 24.6415C6.65769 24.5337 6.67926 24.469 6.70082 24.4043C7.56335 21.7089 8.40432 19.0351 9.26686 16.3396C9.33155 16.1671 9.28842 16.0809 9.13748 15.9731C6.93802 14.3558 4.71699 12.7386 2.51753 11.1213C2.43128 11.0566 2.36659 11.0135 2.28033 10.9488C2.32346 10.9488 2.32346 10.9488 2.32346 10.9272Z" stroke="black" stroke-miterlimit="10"/>
							</svg>
							<svg width="13" height="12" viewBox="0 0 28 26" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M2.32346 10.9272C2.40971 10.9272 2.4744 10.9272 2.56066 10.9272C5.36389 10.9272 8.16713 10.9272 10.9704 10.9272C11.0997 10.9272 11.1429 10.8841 11.1644 10.7763C12.0701 8.01619 12.9758 5.25608 13.8814 2.49597C13.903 2.43128 13.9245 2.38815 13.9677 2.28033C14.1833 2.92723 14.3774 3.55257 14.5714 4.17791C15.2615 6.35581 15.9299 8.51214 16.62 10.69C16.6846 10.8625 16.7493 10.9272 16.9434 10.9272C19.7466 10.9272 22.5714 10.9272 25.3747 10.9272C25.4609 10.9272 25.5472 10.9272 25.6766 10.9272C25.5903 10.9919 25.5472 11.0351 25.5041 11.0782C23.2183 12.7386 20.9542 14.3774 18.6685 16.0378C18.6469 16.0593 18.6038 16.0809 18.5822 16.1024C18.4097 16.1887 18.3666 16.2965 18.4313 16.4906C19.2938 19.1213 20.1348 21.752 20.9973 24.3828C21.0189 24.4475 21.0404 24.5337 21.0836 24.6631C20.9758 24.5984 20.9111 24.5553 20.8464 24.5121C18.6038 22.8733 16.3828 21.2345 14.1617 19.5957C14.0108 19.4879 13.903 19.4663 13.752 19.5957C11.4448 21.2345 9.15904 22.8733 6.85176 24.4906C6.78707 24.5337 6.72238 24.5768 6.63613 24.6415C6.65769 24.5337 6.67926 24.469 6.70082 24.4043C7.56335 21.7089 8.40432 19.0351 9.26686 16.3396C9.33155 16.1671 9.28842 16.0809 9.13748 15.9731C6.93802 14.3558 4.71699 12.7386 2.51753 11.1213C2.43128 11.0566 2.36659 11.0135 2.28033 10.9488C2.32346 10.9488 2.32346 10.9488 2.32346 10.9272Z" stroke="black" stroke-miterlimit="10"/>
							</svg>
            </span>
					</div>
					<div class="surface-key-reviews__date">${data?.created_at}</div>
				</div>
				<div class="surface-key-reviews__content">
					<div class="surface-key-reviews__title">${data?.title}</div>
					<div class="surface-key-reviews__description">${data?.description}</div>
				</div>
			</div>
		`
	}
}

function renderRatingSummary(data) {
	const elements = document.querySelectorAll(".progress-width")
	// Loop through the elements and add styles
	for (let i = 0; i < elements.length; i++) {
		elements[i].style.backgroundColor = localStorage.getItem("star_color")
	}
	document.querySelector("[average-rating]").textContent =
		data?.average_rating?.toFixed(1)
	document
		.querySelector("[rating-star]")
		.classList.add("rating-" + Math.round(data?.average_rating))
	document.querySelector("[rating-star]").style.fill =
		localStorage.getItem("star_color")
	document.querySelector("[rating-star]").style.stroke =
		localStorage.getItem("star_color")
	document.querySelector("[review-count]").textContent = data.total_reviews
	document.querySelector(".rating-star-5 .progress-width").style.width =
		Math.round((data.reviews_summary[4].reviews * 100) / data.total_reviews) +
		"%"
	document.querySelector(".rating-star-5 .star-count").textContent =
		data.reviews_summary[4].reviews
	document.querySelector(".rating-star-4 .progress-width").style.width =
		Math.round((data.reviews_summary[3].reviews * 100) / data.total_reviews) +
		"%"
	document.querySelector(".rating-star-4 .star-count").textContent =
		data.reviews_summary[3].reviews
	document.querySelector(".rating-star-3 .progress-width").style.width =
		Math.round((data.reviews_summary[2].reviews * 100) / data.total_reviews) +
		"%"
	document.querySelector(".rating-star-3 .star-count").textContent =
		data.reviews_summary[2].reviews
	document.querySelector(".rating-star-2 .progress-width").style.width =
		Math.round((data.reviews_summary[1].reviews * 100) / data.total_reviews) +
		"%"
	document.querySelector(".rating-star-2 .star-count").textContent =
		data.reviews_summary[1].reviews
	document.querySelector(".rating-star-1 .progress-width").style.width =
		Math.round((data.reviews_summary[0].reviews * 100) / data.total_reviews) +
		"%"
	document.querySelector(".rating-star-1 .star-count").textContent =
		data.reviews_summary[0].reviews
}

function renderRatingStars(data) {
	let reviewStars = `
      <div class="wholescale-star-widget">
        <div class="rating-container-top">
          <div class="average-rating-and-star">
            <span class="star rating rating-${Math.round(
							data?.average_rating
						)}" rating-star style="fill:${localStorage.getItem(
		"star_color"
	)}; stroke:${localStorage.getItem("star_color")}">
              <svg width="28" height="26" viewBox="0 0 28 26" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M2.32346 10.9272C2.40971 10.9272 2.4744 10.9272 2.56066 10.9272C5.36389 10.9272 8.16713 10.9272 10.9704 10.9272C11.0997 10.9272 11.1429 10.8841 11.1644 10.7763C12.0701 8.01619 12.9758 5.25608 13.8814 2.49597C13.903 2.43128 13.9245 2.38815 13.9677 2.28033C14.1833 2.92723 14.3774 3.55257 14.5714 4.17791C15.2615 6.35581 15.9299 8.51214 16.62 10.69C16.6846 10.8625 16.7493 10.9272 16.9434 10.9272C19.7466 10.9272 22.5714 10.9272 25.3747 10.9272C25.4609 10.9272 25.5472 10.9272 25.6766 10.9272C25.5903 10.9919 25.5472 11.0351 25.5041 11.0782C23.2183 12.7386 20.9542 14.3774 18.6685 16.0378C18.6469 16.0593 18.6038 16.0809 18.5822 16.1024C18.4097 16.1887 18.3666 16.2965 18.4313 16.4906C19.2938 19.1213 20.1348 21.752 20.9973 24.3828C21.0189 24.4475 21.0404 24.5337 21.0836 24.6631C20.9758 24.5984 20.9111 24.5553 20.8464 24.5121C18.6038 22.8733 16.3828 21.2345 14.1617 19.5957C14.0108 19.4879 13.903 19.4663 13.752 19.5957C11.4448 21.2345 9.15904 22.8733 6.85176 24.4906C6.78707 24.5337 6.72238 24.5768 6.63613 24.6415C6.65769 24.5337 6.67926 24.469 6.70082 24.4043C7.56335 21.7089 8.40432 19.0351 9.26686 16.3396C9.33155 16.1671 9.28842 16.0809 9.13748 15.9731C6.93802 14.3558 4.71699 12.7386 2.51753 11.1213C2.43128 11.0566 2.36659 11.0135 2.28033 10.9488C2.32346 10.9488 2.32346 10.9488 2.32346 10.9272Z" stroke="black" stroke-miterlimit="10"/>
							</svg>
              <svg width="28" height="26" viewBox="0 0 28 26" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M2.32346 10.9272C2.40971 10.9272 2.4744 10.9272 2.56066 10.9272C5.36389 10.9272 8.16713 10.9272 10.9704 10.9272C11.0997 10.9272 11.1429 10.8841 11.1644 10.7763C12.0701 8.01619 12.9758 5.25608 13.8814 2.49597C13.903 2.43128 13.9245 2.38815 13.9677 2.28033C14.1833 2.92723 14.3774 3.55257 14.5714 4.17791C15.2615 6.35581 15.9299 8.51214 16.62 10.69C16.6846 10.8625 16.7493 10.9272 16.9434 10.9272C19.7466 10.9272 22.5714 10.9272 25.3747 10.9272C25.4609 10.9272 25.5472 10.9272 25.6766 10.9272C25.5903 10.9919 25.5472 11.0351 25.5041 11.0782C23.2183 12.7386 20.9542 14.3774 18.6685 16.0378C18.6469 16.0593 18.6038 16.0809 18.5822 16.1024C18.4097 16.1887 18.3666 16.2965 18.4313 16.4906C19.2938 19.1213 20.1348 21.752 20.9973 24.3828C21.0189 24.4475 21.0404 24.5337 21.0836 24.6631C20.9758 24.5984 20.9111 24.5553 20.8464 24.5121C18.6038 22.8733 16.3828 21.2345 14.1617 19.5957C14.0108 19.4879 13.903 19.4663 13.752 19.5957C11.4448 21.2345 9.15904 22.8733 6.85176 24.4906C6.78707 24.5337 6.72238 24.5768 6.63613 24.6415C6.65769 24.5337 6.67926 24.469 6.70082 24.4043C7.56335 21.7089 8.40432 19.0351 9.26686 16.3396C9.33155 16.1671 9.28842 16.0809 9.13748 15.9731C6.93802 14.3558 4.71699 12.7386 2.51753 11.1213C2.43128 11.0566 2.36659 11.0135 2.28033 10.9488C2.32346 10.9488 2.32346 10.9488 2.32346 10.9272Z" stroke="black" stroke-miterlimit="10"/>
							</svg>
              <svg width="28" height="26" viewBox="0 0 28 26" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M2.32346 10.9272C2.40971 10.9272 2.4744 10.9272 2.56066 10.9272C5.36389 10.9272 8.16713 10.9272 10.9704 10.9272C11.0997 10.9272 11.1429 10.8841 11.1644 10.7763C12.0701 8.01619 12.9758 5.25608 13.8814 2.49597C13.903 2.43128 13.9245 2.38815 13.9677 2.28033C14.1833 2.92723 14.3774 3.55257 14.5714 4.17791C15.2615 6.35581 15.9299 8.51214 16.62 10.69C16.6846 10.8625 16.7493 10.9272 16.9434 10.9272C19.7466 10.9272 22.5714 10.9272 25.3747 10.9272C25.4609 10.9272 25.5472 10.9272 25.6766 10.9272C25.5903 10.9919 25.5472 11.0351 25.5041 11.0782C23.2183 12.7386 20.9542 14.3774 18.6685 16.0378C18.6469 16.0593 18.6038 16.0809 18.5822 16.1024C18.4097 16.1887 18.3666 16.2965 18.4313 16.4906C19.2938 19.1213 20.1348 21.752 20.9973 24.3828C21.0189 24.4475 21.0404 24.5337 21.0836 24.6631C20.9758 24.5984 20.9111 24.5553 20.8464 24.5121C18.6038 22.8733 16.3828 21.2345 14.1617 19.5957C14.0108 19.4879 13.903 19.4663 13.752 19.5957C11.4448 21.2345 9.15904 22.8733 6.85176 24.4906C6.78707 24.5337 6.72238 24.5768 6.63613 24.6415C6.65769 24.5337 6.67926 24.469 6.70082 24.4043C7.56335 21.7089 8.40432 19.0351 9.26686 16.3396C9.33155 16.1671 9.28842 16.0809 9.13748 15.9731C6.93802 14.3558 4.71699 12.7386 2.51753 11.1213C2.43128 11.0566 2.36659 11.0135 2.28033 10.9488C2.32346 10.9488 2.32346 10.9488 2.32346 10.9272Z" stroke="black" stroke-miterlimit="10"/>
							</svg>
              <svg width="28" height="26" viewBox="0 0 28 26" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M2.32346 10.9272C2.40971 10.9272 2.4744 10.9272 2.56066 10.9272C5.36389 10.9272 8.16713 10.9272 10.9704 10.9272C11.0997 10.9272 11.1429 10.8841 11.1644 10.7763C12.0701 8.01619 12.9758 5.25608 13.8814 2.49597C13.903 2.43128 13.9245 2.38815 13.9677 2.28033C14.1833 2.92723 14.3774 3.55257 14.5714 4.17791C15.2615 6.35581 15.9299 8.51214 16.62 10.69C16.6846 10.8625 16.7493 10.9272 16.9434 10.9272C19.7466 10.9272 22.5714 10.9272 25.3747 10.9272C25.4609 10.9272 25.5472 10.9272 25.6766 10.9272C25.5903 10.9919 25.5472 11.0351 25.5041 11.0782C23.2183 12.7386 20.9542 14.3774 18.6685 16.0378C18.6469 16.0593 18.6038 16.0809 18.5822 16.1024C18.4097 16.1887 18.3666 16.2965 18.4313 16.4906C19.2938 19.1213 20.1348 21.752 20.9973 24.3828C21.0189 24.4475 21.0404 24.5337 21.0836 24.6631C20.9758 24.5984 20.9111 24.5553 20.8464 24.5121C18.6038 22.8733 16.3828 21.2345 14.1617 19.5957C14.0108 19.4879 13.903 19.4663 13.752 19.5957C11.4448 21.2345 9.15904 22.8733 6.85176 24.4906C6.78707 24.5337 6.72238 24.5768 6.63613 24.6415C6.65769 24.5337 6.67926 24.469 6.70082 24.4043C7.56335 21.7089 8.40432 19.0351 9.26686 16.3396C9.33155 16.1671 9.28842 16.0809 9.13748 15.9731C6.93802 14.3558 4.71699 12.7386 2.51753 11.1213C2.43128 11.0566 2.36659 11.0135 2.28033 10.9488C2.32346 10.9488 2.32346 10.9488 2.32346 10.9272Z" stroke="black" stroke-miterlimit="10"/>
							</svg>
              <svg width="28" height="26" viewBox="0 0 28 26" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M2.32346 10.9272C2.40971 10.9272 2.4744 10.9272 2.56066 10.9272C5.36389 10.9272 8.16713 10.9272 10.9704 10.9272C11.0997 10.9272 11.1429 10.8841 11.1644 10.7763C12.0701 8.01619 12.9758 5.25608 13.8814 2.49597C13.903 2.43128 13.9245 2.38815 13.9677 2.28033C14.1833 2.92723 14.3774 3.55257 14.5714 4.17791C15.2615 6.35581 15.9299 8.51214 16.62 10.69C16.6846 10.8625 16.7493 10.9272 16.9434 10.9272C19.7466 10.9272 22.5714 10.9272 25.3747 10.9272C25.4609 10.9272 25.5472 10.9272 25.6766 10.9272C25.5903 10.9919 25.5472 11.0351 25.5041 11.0782C23.2183 12.7386 20.9542 14.3774 18.6685 16.0378C18.6469 16.0593 18.6038 16.0809 18.5822 16.1024C18.4097 16.1887 18.3666 16.2965 18.4313 16.4906C19.2938 19.1213 20.1348 21.752 20.9973 24.3828C21.0189 24.4475 21.0404 24.5337 21.0836 24.6631C20.9758 24.5984 20.9111 24.5553 20.8464 24.5121C18.6038 22.8733 16.3828 21.2345 14.1617 19.5957C14.0108 19.4879 13.903 19.4663 13.752 19.5957C11.4448 21.2345 9.15904 22.8733 6.85176 24.4906C6.78707 24.5337 6.72238 24.5768 6.63613 24.6415C6.65769 24.5337 6.67926 24.469 6.70082 24.4043C7.56335 21.7089 8.40432 19.0351 9.26686 16.3396C9.33155 16.1671 9.28842 16.0809 9.13748 15.9731C6.93802 14.3558 4.71699 12.7386 2.51753 11.1213C2.43128 11.0566 2.36659 11.0135 2.28033 10.9488C2.32346 10.9488 2.32346 10.9488 2.32346 10.9272Z" stroke="black" stroke-miterlimit="10"/>
							</svg>
            </span>
          </div>
          <div class="total-review-and-label">
          <span class="review-count"> ${
						data?.total_reviews == 1
							? data?.total_reviews + " review"
							: data?.total_reviews > 0
							? data?.total_reviews + " reviews"
							: "No reviews"
					} </span>
          </div>
        </div>
      </div>
    `
	const container = document.createElement("div")
	container.innerHTML = reviewStars
	document
		.querySelector(".product-title")
		.insertAdjacentElement("afterend", container)
	document
		.querySelector(".rating-container-top")
		.addEventListener("click", (event) => {
			document
				.querySelector(".wholescale-review-widget")
				.scrollIntoView({ behavior: "smooth" })
		})
}
function renderImages(data) {
	const imagesList = document.querySelector(".images-grid")
	const popupContainer = document.querySelector(".review-popup-container")
	const popupInner = document.querySelector(".review-popup-inner")
	const popupCloseSelector = document.querySelector(".popup-close")
	const popupImage = document.querySelector(".review-popup-left img")
	const popupName = document.querySelector(".review-popup-container .name")
	const ratingContainer = document.querySelector(
		".review-popup-container .rating"
	)
	const dateSelector = document.querySelector(".review-popup-container .date")
	const titleSelector = document.querySelector(
		".review-popup-container .review-title"
	)
	const descriptionSelector = document.querySelector(
		".review-popup-container .review-description"
	)
	const thumbsUpSelector = document.querySelector(
		".review-popup-container .thumbs-up"
	)
	const thumbsDownSelector = document.querySelector(
		".review-popup-container .thumbs-down"
	)
	const thumbsUpDownSelector = document.querySelector(
		".review-popup-container .thumbs-up-down"
	)
	// Set the styles
	ratingContainer.style.fill = localStorage.getItem("star_color")
		? localStorage.getItem("star_color")
		: "rgb(0, 0, 0)"
	ratingContainer.style.stroke = localStorage.getItem("star_color")
		? localStorage.getItem("star_color")
		: "rgb(0, 0, 0)"
	imagesList.innerHTML = ""
	data.forEach(function (item, index) {
		let imageItem = `
        <div class="review-image" data-index=${index} data-review-json="${encodeURIComponent(
			JSON.stringify(item)
		)}">
            <img src=${item.submission_images[0].image} alt="Image ${index}" />
          </div>
        `
		imagesList.innerHTML += imageItem
	})
	imagesList.addEventListener("click", (event) => {
		console.log("event.target.classList", event.target.classList)
		if (
			event.target.classList.contains("review-image") ||
			event.target.closest(".review-image")
		) {
			const index = event.target
				.closest(".review-image")
				.getAttribute("data-index")
			const json = decodeURIComponent(
				event.target.closest(".review-image").getAttribute("data-review-json")
			)
			const data = JSON.parse(json)
			popupImage.setAttribute("src", data?.submission_images[0]?.image)
			popupName.textContent = data?.customer?.first_name
			dateSelector.textContent = data?.created_at
			titleSelector.textContent = data?.title
			descriptionSelector.textContent = data?.description
			thumbsUpDownSelector.setAttribute("data-review-id", data?.id)
			popupContainer
				.querySelector(".thumbs-up")
				.querySelector("span").textContent = data?.liked_count
				? data?.liked_count
				: 0
			popupContainer
				.querySelector(".thumbs-down")
				.querySelector("span").textContent = data?.disliked_count
				? data?.liked_count
				: 0
			if (data?.liked_count > data?.disliked_count && data?.liked_count > 5) {
				document.querySelector(".would-recommend").style.display = "flex"
			} else {
				document.querySelector(".would-recommend").style.display = "none"
			}
			ratingContainer.classList.forEach((className) => {
				if (className !== "rating") {
					ratingContainer.classList.remove(className)
				}
			})
			ratingContainer.classList.add("rating-" + data?.stars)
			// You can now use the data as needed
			setTimeout(function () {
				popupContainer.style.display = "block"
				document.addEventListener("click", updatePopup)
			}, 100)
		}
	})

	// Thumbs up click event
	thumbsUpSelector.addEventListener("click", (event) => {
		if (event.target.closest(".block-click")) {
			return
		}
		const reviewId = event.target
			.closest(".thumbs-up-down")
			.getAttribute("data-review-id")
		const thumbsUpBody = {
			id: reviewId,
			is_liked: true,
		}
		const thumbsUpCounter = event.target
			.closest(".thumbs-up")
			.querySelector("span").textContent
		event.target.closest(".thumbs-up").querySelector("span").textContent =
			Number(thumbsUpCounter) + 1
		event.target.closest(".thumbs-up-down").classList.add("block-click")
		window.submitReviewThumbs(thumbsUpBody, event)
	})
	thumbsDownSelector.addEventListener("click", (event) => {
		event.target.closest(".thumbs-up-down").classList.add("block-click")
		if (event.target.closest(".block-click")) {
			return
		}
		const reviewId = event.target
			.closest(".thumbs-up-down")
			.getAttribute("data-review-id")
		const thumbsDownBody = {
			id: reviewId,
			is_liked: false,
		}
		const thumbsDownCounter = event.target
			.closest(".thumbs-down")
			.querySelector("span").textContent
		event.target.closest(".thumbs-down").querySelector("span").textContent =
			Number(thumbsDownCounter) + 1
		event.target.closest(".thumbs-up-down").classList.add("block-click")
		window.submitReviewThumbs(thumbsDownBody, event)
	})
	// Close Popup
	popupCloseSelector?.addEventListener("click", (event) => {
		setTimeout(function () {
			popupContainer.style.display = "none"
			document.removeEventListener("click", updatePopup)
		}, 100)
	})

	// Close drawer when click outside of review drawer
	function updatePopup(event) {
		// Check if the clicked element is the element you want to keep visible
		if (event.target !== popupInner && !popupInner.contains(event.target)) {
			// Hide the element if it is not the element you want to keep visible
			popupContainer.style.display = "none"
			document.removeEventListener("click", updatePopup)
		}
	}
}
// Wholescale Widget Api's
function fetchWholescaleWidgetInfo() {
	const productId = document
		.querySelector("[data-product-id]")
		.getAttribute("data-product-id")
	window["fetchReviewsList"] = function (cursor) {
		let url = "https://be.wholescale.net/shopifyWidget/reviewList"
		let params = `?product=${productId}&shop_url=${Shopify.shop}`
		console.log("defaultSortBy", defaultSortBy)
		let cursorURI = encodeURIComponent(cursor)
		if (cursor) {
			params += `&cursor=${cursorURI}&limit=10`
		} else {
			params += `&page=1&limit=10`
		}
		if (defaultSortBy?.length > 0) {
			defaultSortBy = defaultSortBy.replace(/-/g, " ")
			params += `&sort_by=${defaultSortBy}`
		}
		if (searchTerm?.length > 0) {
			params += `&search=${encodeURIComponent(searchTerm)}`
		}
		url = url + params

		const requestOptions = {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
			},
		}
		fetch(url, requestOptions)
			.then((response) => response.json())
			.then((data) => {
				console.log("Response:", data)
				// Process the response data here
				if (data.results.length > 0) {
					renderReviews(data)
					document.querySelector(".no-reviews").style.display = "none"
				} else {
					document.querySelector(".no-reviews").style.display = "block"
					document.querySelector(".reviews-list-inner").innerHTML = ""
				}
				if (!data.next && !data.previous) {
					console.log("no next no prev")
					document.querySelector("#review-pagination").style.display = "none"
				}
				if (data.previous) {
					let url = new URL(data.previous)
					let urlParams = new URLSearchParams(url.search)
					let prevCursor = urlParams.get("cursor")
					document.querySelector("#review-pagination").style.display = "flex"
					document
						.querySelector("#review-pagination .prev")
						?.classList.remove("wholescale-disabled")
					document
						.querySelector("#review-pagination .prev")
						?.setAttribute("data-cursor", prevCursor)
				} else {
					document
						.querySelector("#review-pagination .prev")
						?.classList.add("wholescale-disabled")
				}
				if (data.next) {
					let url = new URL(data.next)
					let urlParams = new URLSearchParams(url.search)
					let nextCursor = urlParams.get("cursor")
					document.querySelector("#review-pagination").style.display = "flex"
					document
						.querySelector("#review-pagination .next")
						?.classList.remove("wholescale-disabled")
					document
						.querySelector("#review-pagination .next")
						?.setAttribute("data-cursor", nextCursor)
				} else {
					document
						.querySelector("#review-pagination .next")
						?.classList.add("wholescale-disabled")
				}
				document
					.querySelector("[reviews-container]")
					.classList.remove("loading")
			})
			.catch((error) => {
				console.error("Error:", error)
				// Handle any errors that occurred during the request
			})
	}
	window["fetchQuestionsList"] = function (cursor) {
		let url = "https://be.wholescale.net/shopifyWidget/questionList"
		let params = `?product=${productId}&shop_url=${Shopify.shop}&page=1&limit=10`
		let cursorURI = encodeURIComponent(cursor)
		if (cursor) {
			params += `&cursor=${cursorURI}&limit=10`
		} else {
			params += `&page=1&limit=10`
		}
		url = url + params
		const requestOptions = {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
			},
		}
		fetch(url, requestOptions)
			.then((response) => response.json())
			.then((data) => {
				console.log("Response:", data)
				// Process the response data here
				data.results.length > 0
					? renderQuestions(data)
					: (document.querySelector(".no-questions").style.display = "block")
				if (!data.next && !data.previous) {
					document.querySelector("#question-pagination").remove()
				}
				if (data.previous) {
					let url = new URL(data.previous)
					let urlParams = new URLSearchParams(url.search)
					let prevCursor = urlParams.get("cursor")
					document
						.querySelector("#question-pagination .prev")
						?.classList.remove("wholescale-disabled")
					document
						.querySelector("#question-pagination .prev")
						?.setAttribute("data-cursor", prevCursor)
				} else {
					document
						.querySelector("#question-pagination .prev")
						?.classList.add("wholescale-disabled")
				}
				if (data.next) {
					let url = new URL(data.next)
					let urlParams = new URLSearchParams(url.search)
					let nextCursor = urlParams.get("cursor")
					document
						.querySelector("#question-pagination .next")
						?.classList.remove("wholescale-disabled")
					document
						.querySelector("#question-pagination .next")
						?.setAttribute("data-cursor", nextCursor)
				} else {
					document
						.querySelector("#question-pagination .next")
						?.classList.add("wholescale-disabled")
				}

				document
					.querySelector("[questions-container]")
					.classList.remove("loading")
			})
			.catch((error) => {
				console.error("Error:", error)
				// Handle any errors that occurred during the request
			})
	}
	window["fetchReviewImages"] = function () {
		let url = "https://be.wholescale.net/shopifyWidget/mediaReviewList"
		let params = `?product=${productId}&shop_url=${Shopify.shop}`
		if (defaultSortBy?.length > 0) {
			defaultSortBy = defaultSortBy.replace(/-/g, " ")
			params += `&sort_by=${defaultSortBy}`
		}
		url = url + params

		const requestOptions = {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
			},
		}
		fetch(url, requestOptions)
			.then((response) => response.json())
			.then((data) => {
				// console.log("Response:", data);
				// Create a new array of images
				if (!data.length) {
					return
				}
				// const imagesArray = data.map(item => {
				//   // Get the first image key from submission_images
				//   const image = item.submission_images.length > 0 ? item.submission_images[0].image : null;
				//   const reviewItem = item;
				//   return { image, reviewItem };
				// });
				renderImages(data)
				// console.log("reviewItem", reviewItem)
				// Process the response data here
				// renderRatingSummary(data);
				// renderRatingStars(data);
				// window.fetchReviewsList();
			})
			.catch((error) => {
				console.error("Error:", error)
				// Handle any errors that occurred during the request
			})
	}
	function fetchRatingSummary() {
		let url = "https://be.wholescale.net/shopifyWidget/reviewSummary"
		const params = `?product=${productId}&shop_url=${Shopify.shop}`
		url = url + params

		const requestOptions = {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
			},
		}
		fetch(url, requestOptions)
			.then((response) => response.json())
			.then((data) => {
				console.log("Response:", data)
				// Process the response data here
				renderRatingSummary(data)
				renderRatingStars(data)
				window.fetchReviewsList()
				window.fetchReviewImages()
			})
			.catch((error) => {
				console.error("Error:", error)
				// Handle any errors that occurred during the request
			})
	}
	function fetchWidgetSettings() {
		let url = "https://be.wholescale.net/shopifyWidget/widgetSetting"
		const params = `?product=${productId}&shop_url=${Shopify.shop}`
		url = url + params
		const requestOptions = {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
			},
		}
		fetch(url, requestOptions)
			.then((response) => response.json())
			.then((data) => {
				// Process the response data here
				data.status
					? handleWidgetSettings(data)
					: document.querySelector(".wholescale-review-widget").remove()
				localStorage.setItem("star_color", data.star_color)
			})
			.catch((error) => {
				console.error("Error:", error)
				// Handle any errors that occurred during the request
			})
		function handleWidgetSettings(data) {
			defaultSortBy = data.sorting_type.toLowerCase().replace(/\s+/g, "-")
			searchTerm = ""
			if (defaultSortBy?.length > 0) {
				document
					.querySelector(".sortby-dropdown > span.active")
					.classList.remove("active")

				document
					.querySelector(".sortby-dropdown > span.sortby-" + defaultSortBy)
					.classList.add("active")
				document.querySelector("[sortby-value]").textContent = defaultSortBy
			}
			if (data.add_reviews) {
				fetchRatingSummary()
				document.querySelector("[rating-star]").style.fill = window.star_color
				document.querySelector(
					"#review_form .add-photo"
				).style.backgroundColor = data.button_background_color
				document.querySelector("#review_form .add-photo").style.color =
					data.button_text_color
				document.querySelector(".add-review-inner").style.backgroundColor =
					data.button_background_color
				document.querySelector(".add-review-inner").style.color =
					data.button_text_color
				document.querySelector(
					".write-review-inner .widget-drawer-close"
				).style.backgroundColor = data.button_background_color
				document.querySelector(
					".write-review-inner .widget-drawer-close"
				).style.color = data.button_text_color
				document.querySelector(
					".write-review-inner [type=submit]"
				).style.backgroundColor = data.button_background_color
				document.querySelector(
					".write-review-inner [type=submit]"
				).style.color = data.button_text_color
			} else if (data.add_reviews == false) {
				document
					.querySelector(".review-widget [data-tab-value='reviews']")
					.remove()
				document.querySelector("[reviews-container]").remove()
				document.querySelector(".rating-container").remove()
				document.querySelector("[questions-container]").classList.add("active")
				document
					.querySelector("[data-tab-value='questions']")
					.classList.add("active")
			}
			if (data.add_questions) {
				window.fetchQuestionsList()
				document.querySelector(
					"#question_form .add-photo"
				).style.backgroundColor = data.button_background_color
				document.querySelector("#question_form .add-photo").style.color =
					data.button_text_color
				document.querySelector(".ask-question-inner").style.backgroundColor =
					data.button_background_color
				document.querySelector(".ask-question-inner").style.color =
					data.button_text_color
				document.querySelector(
					".question-form-inner .widget-drawer-close"
				).style.backgroundColor = data.button_background_color
				document.querySelector(
					".question-form-inner .widget-drawer-close"
				).style.color = data.button_text_color
				document.querySelector(
					".question-form-inner [type=submit]"
				).style.backgroundColor = data.button_background_color
				document.querySelector(
					".question-form-inner [type=submit]"
				).style.color = data.button_text_color
			} else if (data.add_questions == false) {
				document
					.querySelector(".review-widget [data-tab-value='questions']")
					.remove()
			}
			if (!data.add_reviews_media) {
				document.querySelector("[review-form] .wholescale-file-upload").remove()
			}
			if (!data.add_questions_media) {
				document
					.querySelector("[question-form] .wholescale-file-upload")
					.remove()
			}
		}
	}
	fetchWidgetSettings()
	// updateRatingInfo(data);
}
